const TechpressoDashboard = () => {
  return <div>TechpressoDashboard</div>;
};

export default TechpressoDashboard;
